// 2026-05-26 - FormuLearning - 로그인 폼 컴포넌트
// 파일 위치: frontend/src/features/auth/LoginForm.tsx

import { useState } from 'react'
import { useAuthStore } from '../../stores/authStore'

export default function LoginForm({ onToggle }: { onToggle: () => void }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const login = useAuthStore((s) => s.login)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
    } catch {
      setError('Invalid email or password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label className="mb-1 block text-xs font-medium text-text-secondary">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none focus:ring-2"
          style={{ borderColor: 'var(--border-soft)', boxShadow: email ? 'var(--elev-focus)' : 'none' }}
          placeholder="admin@formulearn.dev"
          required
        />
      </div>
      <div>
        <label className="mb-1 block text-xs font-medium text-text-secondary">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-md border bg-bg-input px-3 py-2 text-sm text-text-body outline-none focus:ring-2"
          style={{ borderColor: 'var(--border-soft)' }}
          placeholder="Enter password"
          required
        />
      </div>
      {error && <p className="text-sm text-danger">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="w-full rounded-md bg-accent-purple px-4 py-2 text-sm font-semibold text-[#1a1b1e] transition-opacity hover:opacity-90 disabled:opacity-50"
      >
        {loading ? 'Signing in...' : 'Sign In'}
      </button>
      <p className="text-center text-xs text-text-secondary">
        Don't have an account?{' '}
        <button type="button" onClick={onToggle} className="text-accent-purple hover:underline">
          Register
        </button>
      </p>
    </form>
  )
}
